<template>
    <div class="k-flex-col">
        <div>
            <b-input-group>
                <template #prepend>
                    <b-input-group-text>
                        <b-icon-search />
                    </b-input-group-text>
                </template>
                <b-form-input
                    placeholder="Rechercher un projet"
                    v-model="filter"
                    debounce="500"
                />
                <template #append>
                    <b-button variant="secondary" @click="filter = ''">
                        Effacer
                    </b-button>
                </template>
            </b-input-group>
        </div>
        <b-table
            class="text-break mt-2 text-center"
            :items="dataProvider"
            :fields="fields"
            :current-page="currentPage"
            :filter="filter"
            show-empty
            empty-text="Aucun projet"
            empty-filtered-text="Aucun projet trouvé"
            stacked="md"
            hover
            tbody-tr-class="pointer"
            @row-clicked="goProject"
            striped
        >
            <template #cell(role)="data">
                {{ data.item.ProjectUser.role }}
            </template>
            <template #cell(credentials)="data">
                {{ data.item.ProjectUser.credentials | projectRoleFromCreds }}
            </template>
            <template #cell(createdAt)="data">
                {{ data.item.createdAt | dateFromISO(true) }}
            </template>
            <template #table-busy>
                <div class="text-center my-2">
                    <b-spinner class="align-middle"></b-spinner>
                    <strong class="ml-2">Chargement des données...</strong>
                </div>
            </template>
        </b-table>
        <div>
            <b-pagination
                class="m-auto"
                v-model="currentPage"
                :per-page="perPage"
                :total-rows="totalRows"
                align="center"
                size="sm"
                first-number
                last-number
            />
        </div>
    </div>
</template>

<script>
export default {
    props: {
        clickTarget: { type: String, default: "AdminProject" },
        perPage: { type: String, default: "8" },
        userId: [String, Number],
    },

    data: function() {
        return {
            totalRows: 0,
            currentPage: 1,
            fields: [
                {
                    key: "name",
                    label: "Projet",
                    sortable: true,
                    tdClass: "text-left text-kalkin-1 font-weight-bold",
                },
                {
                    key: "description",
                    label: "Description",
                    tdClass: "text-left",
                },
                {
                    key: "role",
                    label: "Rôle",
                },
                {
                    key: "credentials",
                    label: "Droits",
                },
                {
                    key: "createdAt",
                    label: "Création",
                    sortable: true,
                },
            ],
            filter: "",
        };
    },

    watch: {
        async filter() {
            await this.fetchTotalRows();
        },
    },

    methods: {
        async fetchTotalRows() {
            this.totalRows = await this.$store.dispatch(
                "user/countFSPUserProjects",
                {
                    userId: this.userId,
                    filter: `name substring ${this.filter}`,
                },
            );
        },

        async dataProvider(ctx) {
            return await this.$store.dispatch("user/getFSPUserProjects", {
                userId: this.userId,
                filter: `name substring ${this.filter}`,
                sortby: (ctx.sortDesc ? "-" : "") + ctx.sortBy,
                limit: this.perPage,
                offset: this.perPage * (this.currentPage - 1),
            });
        },

        goProject(item) {
            this.$router.push({
                name: this.clickTarget,
                params: { projectId: item.id },
            });
        },
    },

    async beforeMount() {
        await this.fetchTotalRows();
    },
};
</script>

<style></style>
